import Vue from 'vue'
import { router } from './routing'
import { store } from './store'
import App from './App'

/**
 * Install components and packages.
 */
import './components'
import './packages'


new Vue({
  store,
  router,
  render: h => h(App),
  data: {
    base: process.env.VUE_APP_BASE_URL
  },
  beforeCreate() {
    store.dispatch('auth/user').catch(() => {})
  }
}).$mount('#app')